// @flow
import React from "react"
import classnames from "classnames"

const ICON_SIZE = 16

type Props = {
  size?: number,
  // eslint-disable-next-line flowtype/no-weak-types
  style?: string | Object,
  old?: boolean,
  className?: string,
  active?: boolean,
}

const Spinner = ({ size, style, old, className, active = true }: Props) => {
  /* it is inline because there will be more options it will be easily parameterizable, but maybe i am just lazy */

  if (active) {
    if (!old) {
      const bounceStyle = {
        width: size || 10,
        height: size || 10,
      }
      return (
        <div className={classnames("Spinner", className)} style={style}>
          <div style={bounceStyle} className="bounce1" />
          <div style={bounceStyle} className="bounce2" />
          <div style={bounceStyle} className="bounce3" />
        </div>
      )
    }
    const customStyle = {
      width: ICON_SIZE,
      height: ICON_SIZE,
      display: "inline-block",
      verticalAlign: "middle",
      marginLeft: "5px",
    }
    return <img style={customStyle} src="/images/general/ajax-16.gif" width={size} height={size} />
  }
  return <span style={style} />
}

export default Spinner
